import React from 'react';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { useAppTheme } from '../AppThemeProvider';

export function ThemeToggle() {
  const { mode, toggleColorMode } = useAppTheme();
  const theme = useTheme();

  return (
    <Tooltip title={mode === 'dark' ? '切换到浅色模式' : '切换到深色模式'}>
      <IconButton onClick={toggleColorMode} color="inherit">
        {mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
      </IconButton>
    </Tooltip>
  );
}
